const SimpleTable = ({ columns = [], data = [], loading = false, emptyText = 'Мэдээлэл олдсонгүй' }) => {
  return (
    <div className="rounded-2xl border bg-white shadow-sm overflow-hidden">
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 border-b">
            <tr>
              {columns.map((col) => (
                <th
                  key={col.key}
                  className={`px-3 py-2 font-medium bg-gray-50 ${col.align === 'right'
                    ? 'text-right'
                    : col.align === 'center'
                      ? 'text-center'
                      : 'text-center'
                    }`}
                >
                  {col.title}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {loading ? (
              <tr>
                <td colSpan={columns.length} className="px-4 py-10 text-center text-slate-500">
                  Уншиж байна...
                </td>
              </tr>
            ) : data.length === 0 ? (
              <tr>
                <td colSpan={columns.length} className="px-4 py-10 text-center text-slate-500">
                  {emptyText}
                </td>
              </tr>
            ) : (
              data.map((row, rowIndex) => (
                <tr key={row.id || rowIndex} className="border-b last:border-b-0 hover:bg-slate-50/70">
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      className={`px-3 py-2 ${col.align === 'right'
                          ? 'text-right'
                          : col.align === 'center'
                            ? 'text-center'
                            : 'text-left'
                        }`}
                    >
                      {col.render ? col.render(row) : row[col.key]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className="md:hidden divide-y">
        {loading ? (
          <div className="p-6 text-center text-slate-500">Уншиж байна...</div>
        ) : data.length === 0 ? (
          <div className="p-6 text-center text-slate-500">{emptyText}</div>
        ) : (
          data.map((row, rowIndex) => (
            <div key={row.id || rowIndex} className="p-4 space-y-2">
              {columns.map((col) => (
                <div key={col.key} className="flex items-start justify-between gap-3">
                  <div className="text-xs text-slate-500 min-w-[110px]">{col.title}</div>
                  <div className="text-sm text-slate-800 text-right">
                    {col.render ? col.render(row) : row[col.key] ?? ''}
                  </div>
                </div>
              ))}
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default SimpleTable;